module.exports = __webpack_public_path__ + "img/arrow-right-gray.6093a9c5.svg";